import {useContext} from 'react';

import {SessionTextChatBase, SessionTextChatProps} from 'components';
import {ClientContext} from 'context';

import {ClientSessionTextChatView} from './ClientSessionTextChatView';

export const ClientSessionTextChat: React.FC<SessionTextChatProps> = (props: SessionTextChatProps) => {
    const {textChatInputDisabled} = useContext(ClientContext);
    return (
        <SessionTextChatBase
            {...props}
            inputDisabled={props.inputDisabled || textChatInputDisabled}
            TextChatView={ClientSessionTextChatView}
        />
    );
};
